module.exports = __webpack_public_path__ + "img/chestline_small.ef9c1043.png";